import { useIntl } from "react-intl";

import Heading from "@atlaskit/heading";
import { Inline } from "@atlaskit/primitives-next";
import Skeleton from "@atlaskit/skeleton";

import { useFastshiftSelector } from "@/components/fastshift/src/state";
import { Picture } from "@/components/wpl/image/src";

import { messages } from "./messages";

const CustomerLogo = () => {
    const intl = useIntl();

    const { data: customerDomain } = useFastshiftSelector(
        (state) => state.customerDomain
    );

    // placeholder if no logo is available
    if (!customerDomain?.customerLogoUrl) {
        return <Skeleton height="20px" width="20px" borderRadius="4px" />;
    }

    return (
        <Picture
            image={{
                src: customerDomain?.customerLogoUrl || "",
                alt: intl.formatMessage(messages.logoAltText, {
                    name: customerDomain?.customerName
                })
            }}
            style={{
                width: "20px",
                height: "20px",
                borderRadius: "4px"
            }}
        />
    );
};

export const CustomerNameAndLogoHeader = () => {
    const { data: customerDomain, pending: customerDomainPending } =
        useFastshiftSelector((state) => state.customerDomain);

    if (customerDomainPending) {
        return (
            <Inline alignBlock="center" space="space.100">
                <Skeleton height="20px" width="20px" borderRadius="4px" />
                <Skeleton width="300px" height="28px" />
            </Inline>
        );
    }

    return (
        <Inline alignBlock="center" space="space.100">
            <CustomerLogo />
            {customerDomain?.customerName && (
                <Heading size="large">{customerDomain.customerName}</Heading>
            )}
        </Inline>
    );
};
